var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_14019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.631 9.95605H15.5781V29.4672H26.631V9.95605Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2804 19.7088C16.2786 17.8298 16.7121 15.9749 17.548 14.2848C18.3839 12.5946 19.6002 11.1134 21.105 9.95324C19.2416 8.51442 17.0036 7.61963 14.6469 7.37116C12.2902 7.12269 9.90995 7.53055 7.77809 8.54814C5.64624 9.56572 3.84884 11.152 2.59135 13.1256C1.33385 15.0992 0.666992 17.3805 0.666992 19.7088C0.666992 22.0371 1.33385 24.3185 2.59135 26.2921C3.84884 28.2657 5.64624 29.8519 7.77809 30.8695C9.90995 31.8871 12.2902 32.295 14.6469 32.0465C17.0036 31.798 19.2416 30.9032 21.105 29.4644C19.6003 28.3043 18.3839 26.8231 17.548 25.1329C16.7121 23.4427 16.2786 21.5879 16.2804 19.7088Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5419 19.7088C41.542 22.0371 40.8752 24.3184 39.6178 26.292C38.3603 28.2656 36.563 29.8519 34.4312 30.8695C32.2994 31.8871 29.9191 32.295 27.5625 32.0465C25.2058 31.798 22.9679 30.9032 21.1045 29.4644C22.608 28.3031 23.8234 26.8217 24.6591 25.1318C25.4949 23.4418 25.9291 21.5876 25.9291 19.7088C25.9291 17.8301 25.4949 15.9758 24.6591 14.2859C23.8234 12.596 22.608 11.1145 21.1045 9.95325C22.9679 8.51442 25.2058 7.61963 27.5625 7.37116C29.9191 7.12269 32.2994 7.53057 34.4312 8.54816C36.563 9.56576 38.3603 11.152 39.6178 13.1256C40.8752 15.0992 41.542 17.3806 41.5419 19.7088Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3376 27.3981V26.9987H40.5016V26.9173H40.084V26.9987H40.248V27.3981H40.3376ZM41.1483 27.3981V26.9165H41.0203L40.8731 27.2478L40.7258 26.9165H40.5978V27.3981H40.6881V27.0348L40.8262 27.348H40.9199L41.058 27.034V27.3981H41.1483Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_14019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8752,
    height: 40.8752,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.1edccaea.svg";
export { ForwardRef as ReactComponent };